export function transformUrlToIncludePassword(url?: string, plainTextPassword?: string) {
  if (!url) {
    return '';
  }

  if (!plainTextPassword) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.searchParams.has('plainTextPassword')) {
      // eslint-disable-next-line no-console
      console.warn('URL already contains plainTextPassword, not adding it again');
      return url;
    }
    // Set the plainTextPassword as a query parameter
    parsedUrl.searchParams.set('plainTextPassword', plainTextPassword);
    return parsedUrl.toString();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to transform URL:', e);
    // If URL parsing fails, return the original URL
    return url;
  }
}
